/*eslint-disable prefer-const */
import { useEffect, useState } from 'react';
import moment from 'moment';
import { Row, Col, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import Checkbox from 'src/Admin/components/common/Checkbox';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import AutoSuggestionSelectComponent from 'src/Components/auto-suggestion-select/Select';
import { stateOptions } from 'src/utils';
//import APIEndpoints from '../../../../api/APIEndpoints';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
//import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { axiosInstance } from 'src/api/axios';
import { toast } from 'react-toastify';
import ToastMessage from '../../../common/ToastMessage';
import { useDispatch } from 'react-redux';
//import useProfile from '../../../ViewMember/Profile/hooks/useProfile';
import './styles/member-info.scss';

const EditMemberContactInfo = ({
  data,
  nextStep,
  prevStep,
  setShowEditMemberContactDetails,
  enrollmentFormData,
  setEnrollmentFormData,
  loggedInUserOID,
  loggedInMemberType,
  //setResponseData,
}) => {
  console.log('EditMemberContactInfo data', data);
  console.log('EditMemberContactInfo enrollmentFormData', enrollmentFormData);
  //console.log('EditMemberContactInfo responseData', responseData);
  const { insurerApproval, employerApproval } =
    enrollmentFormData.approvalDetails;
  console.log('approvalDetails', insurerApproval, employerApproval);

  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  /*const [addressDetailsSaveSuccess, setAddressDetailsSaveSuccess] =
    useState(false);*/
  //const { fetchEmployeeData } = useProfile();
  const formattedStateOptions = [...stateOptions].map((v) => {
    return { label: v.stateTitle, value: v.State };
  });

  const [useDifferentMailingAddress, setUseDifferentMailingAddress] =
    useState(false);

  //const [residentialData, setResidentialData] = useState({});
  //const [mailingData, setMailingData] = useState({});
  const [submitMemberAddress, setsubmitMemberAddress] = useState(false);

  const ONLYSPACES = /^(?!\s+$).*/;

  const validationSchema = yup.object({
    residence_street: yup
      .string()
      .max(55, 'Enter maximum 55 characters only')
      .required('Enter Street Address')
      .nullable()
      .matches(ONLYSPACES, 'Enter Street Address'),
    residence_apartment: yup
      .string()
      .max(55, 'Enter maximum 55 characters only'),
    residence_city: yup
      .string()
      .max(30, 'Enter maximum 30 characters only')
      .required('Enter City')
      .nullable()
      .matches(ONLYSPACES, 'Enter City'),
    residence_state: yup.string().required('Enter State'),
    residence_zip: yup
      .string()
      .max(15, 'Enter maximum 15 characters only')
      .required('Enter Postal Code')
      .nullable()
      .matches(ONLYSPACES, 'Enter Postal Code'),
    mailing_street: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () =>
          yup
            .string()
            .max(55, 'Enter maximum 55 characters only')
            .required('Enter Street Address')
            .nullable()
            .matches(ONLYSPACES, 'Enter Street Address'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(55, 'Enter maximum 55 characters only'),
      }),
    mailing_apartment: yup.string().max(55, 'Enter maximum 55 characters only'),
    mailing_city: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () =>
          yup
            .string()
            .max(30, 'Enter maximum 30 characters only')
            .required('Enter City')
            .nullable()
            .matches(ONLYSPACES, 'Enter City'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(30, 'Enter maximum 30 characters only'),
      }),
    mailing_state: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () => yup.string().required('Enter State'),
        otherwise: () => yup.string().notRequired(),
      }),
    mailing_zip: yup
      .string()
      .ensure()
      .when('required', {
        is: () => useDifferentMailingAddress,
        then: () =>
          yup
            .string()
            .max(15, 'Enter maximum 15 characters only')
            .required('Enter Postal Code')
            .nullable()
            .matches(ONLYSPACES, 'Enter Postal Code'),
        otherwise: () =>
          yup
            .string()
            .notRequired()
            .max(15, 'Enter maximum 15 characters only'),
      }),
    //mailing_street: yup.string().required('Enter street Address').max(55),
    //mailing_city: yup.string().required('Enter city').min(0).max(30),
    //mailing_state: yup.string().required('Enter State').min(0).max(30),
    //mailing_zip: yup.string().required('Enter postal code').min(0).max(15),
  });

  const [residenceState, setResidenceState] = useState(
    data?.residentialAddress.State ? data?.residentialAddress.State : '',
  );
  const [mailingResidenceState, setMailingResidenceState] = useState(
    data?.mailingAddress && data?.mailingAddress.State
      ? data?.mailingAddress.State
      : '',
  );

  const selectedResidenceState = formattedStateOptions.filter(
    (option) => option.value === residenceState,
  );

  const selectedMailingResidenceState = formattedStateOptions.filter(
    (option) => option.value === mailingResidenceState,
  );

  const initialValues = {
    residence_street: data?.residentialAddress.Address1 || '',
    residence_apartment: data?.residentialAddress.Address2 || '',
    residence_city: data?.residentialAddress.City || '',
    residence_state: data?.residentialAddress.State || '',
    residence_zip: data?.residentialAddress.PostalCode || '',
    mailing_street:
      (data?.mailingAddress && data?.mailingAddress.Address1) || '',
    mailing_apartment:
      (data?.mailingAddress && data?.mailingAddress.Address2) || '',
    mailing_city: (data?.mailingAddress && data?.mailingAddress.City) || '',
    mailing_state: (data?.mailingAddress && data?.mailingAddress.State) || '',
    mailing_zip:
      (data?.mailingAddress && data?.mailingAddress.PostalCode) || '',
  };

  const handlePersonalResidenceStateSelection = (e) => {
    setResidenceState(e.value);
  };
  const handlePersonalMailingResidenceStateSelection = (e) => {
    setMailingResidenceState(e.value);
  };

  const effective_date =
    enrollmentFormData?.adoptionOrBirthDate &&
    moment(enrollmentFormData?.adoptionOrBirthDate).format('YYYY-MM-DD');
  console.log('effective_date', effective_date);

  const updateAddressStateValues = (values) => {
    const maintenanceAddressValues = {
      AddressType: 'R',
      EffectiveDate: effective_date,
      Address1: values?.residence_street,
      Address2: values?.residence_apartment,
      Address3: data?.residentialAddress?.Address3,
      County:
        data?.residentialAddress?.City !== values?.residence_city ||
        data?.residentialAddress?.State !== values?.residence_state ||
        data?.residentialAddress?.PostalCode !== values?.residence_zip
          ? null
          : data?.residentialAddress?.County,
      Country: 'USA',
      City: values?.residence_city,
      State: values?.residence_state,
      PostalCode: values?.residence_zip,
      IncludeGMECovLiveCal: null,
      IncludeTaxCal: null,
    };

    let mailingAddressValues = { ...maintenanceAddressValues };

    if (useDifferentMailingAddress === true) {
      mailingAddressValues = {
        AddressType: 'M',
        EffectiveDate: effective_date,
        Address1: values?.mailing_street,
        Address2: values?.mailing_apartment,
        Address3: data?.mailingAddress?.Address3,
        County:
          data?.mailingAddress?.City !== values?.mailing_city ||
          data?.mailingAddress?.State !== values?.mailing_state ||
          data?.mailingAddress?.PostalCode !== values?.mailing_zip
            ? null
            : data?.mailingAddress?.County,
        Country: 'USA',
        City: values?.mailing_city,
        State: values?.mailing_state,
        PostalCode: values?.mailing_zip,
      };
    }

    const memberAddressValues = {
      maintenanceAddressValues: maintenanceAddressValues,
      mailingAddressValues: mailingAddressValues,
    };

    setEnrollmentFormData({
      ...enrollmentFormData,
      isMemberAddressUpdated: true,
      updateMemberAddress: memberAddressValues,
    });
  };

  const updateAddress = async (values) => {
    console.log(
      'EditMemberContactInfo updateAddress loggedInMemberType',
      loggedInMemberType,
      loggedInUserOID,
    );
    const updatedResidenceAddress = {
      //EffectiveDate: data?.residentialAddress.EffectiveDate,
      EffectiveDate: effective_date,
      Address1: values?.residence_street,
      Address2: values?.residence_apartment,
      Address3: data?.residentialAddress?.Address3,
      County:
        data?.residentialAddress?.City !== values?.residence_city ||
        data?.residentialAddress?.State !== values?.residence_state ||
        data?.residentialAddress?.PostalCode !== values?.residence_zip
          ? null
          : data?.residentialAddress?.County,
      Country: 'USA',
      City: values?.residence_city,
      States: values?.residence_state,
      PostalCode: values?.residence_zip,
    };

    let updatedMailingAddress = { ...updatedResidenceAddress };

    /*updatedMailingAddress.EffectiveDate = data?.mailingAddress.EffectiveDate
      ? data?.mailingAddress.EffectiveDate
      : data?.residentialAddress.EffectiveDate;*/

    if (useDifferentMailingAddress === true) {
      updatedMailingAddress = {
        //EffectiveDate: data?.mailingAddress.EffectiveDate,
        EffectiveDate: effective_date,
        Address1: values?.mailing_street,
        Address2: values?.mailing_apartment,
        Address3: data?.mailingAddress?.Address3,
        County:
          data?.mailingAddress?.City !== values?.mailing_city ||
          data?.mailingAddress?.State !== values?.mailing_state ||
          data?.mailingAddress?.PostalCode !== values?.mailing_zip
            ? null
            : data?.mailingAddress?.County,
        Country: 'USA',
        City: values?.mailing_city,
        States: values?.mailing_state,
        PostalCode: values?.mailing_zip,
      };
    }

    /*const memberAddressDetails = {
      UpdateMemberAddress: {
        EmployeeMaintenanceAdd: [updatedResidenceAddress],
        EmployeeMailingAdd: [updatedMailingAddress],
      },
    };*/

    const memberAddressDetails = {
      AddMemberAddress: {
        EmployeeMaintenanceAdd: [updatedResidenceAddress],
        EmployeeMailingAdd: [updatedMailingAddress],
      },
    };

    console.log('memberAddressDetails', memberAddressDetails);

    /*if (loggedInMemberType === 'Employee') {
      return await axiosInstance.put(
        `${APIEndpoints.updateMemberAddress()}/oid/${loggedInUserOID}`,
        memberAddressDetails,
      );
    }*/

    if (loggedInMemberType === 'Employee') {
      return await axiosInstance.post(
        `${APIEndpoints.enrollmentAddMemberAddress()}/oid/${loggedInUserOID}`,
        memberAddressDetails,
      );
    }
  };

  /*const getMemberData = async () => {
    console.log(
      'EditMemberContactInfo getMemberData',
      loggedInUserOID,
      loggedInMemberType,
    );
    try {
      const params = `oid/${loggedInUserOID}/membertype/${loggedInMemberType}`;
      const responseEmployeeData = await axiosInstance.get(
        APIEndpoints.getViewMemberinformation() + params,
      );
      console.log(
        'EditMemberContactInfo responseEmployeeData',
        responseEmployeeData,
      );
      if (
        responseEmployeeData.status ===
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        responseEmployeeData.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        setResponseData(responseEmployeeData.data);
        setEnrollmentFormData({
          ...enrollmentFormData,
          updatedMemberInformation: responseEmployeeData?.data?.Response || {},
          isMemberAddressUpdated: true,
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  };*/

  const handleSubmit = async (values) => {
    setLoader(true);

    try {
      if (!insurerApproval && !employerApproval) {
        await updateAddress(values);
        toast.success(
          <ToastMessage
            type="success"
            subTitle="Your address change request has been submitted successfully"
          />,
        );
      }
      //getMemberData();
      updateAddressStateValues(values);
      //fetchEmployeeData();
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Your address change request has not been submitted successfully"
        />,
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <Formik
        enableReinitialize
        validateOnMount={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const submittedValues = {
            ...values,
            residence_state: residenceState,
            mailing_street: !useDifferentMailingAddress
              ? data?.mailingAddress.Address1
              : values.mailing_street,
            mailing_apartment: !useDifferentMailingAddress
              ? data?.mailingAddress.Address2
              : values.mailing_apartment,
            mailing_city: !useDifferentMailingAddress
              ? data?.mailingAddress.City
              : values.mailing_city,
            mailing_state: !useDifferentMailingAddress
              ? data?.mailingAddress.State
              : mailingResidenceState,
            mailing_zip: !useDifferentMailingAddress
              ? data?.mailingAddress.PostalCode
              : values.mailing_zip,
          };
          setEnrollmentFormData({
            ...enrollmentFormData,
            memberAddressInfo: submittedValues,
            //isMemberAddressUpdated: true,
          });
          setShowEditMemberContactDetails(false);
          handleSubmit(submittedValues);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          isValid,
          handleReset,
          resetForm,
          setFieldTouched,
          setValues,
          setFieldValue,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className="form-main-container">
                <div className="p-0 m-0 mb-2 mt-4 ml-3 form-section">
                  Residential Address
                </div>
                <Row className="m-0">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>
                        Street Address
                        <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="residence_street"
                        placeholder=""
                        className=""
                        value={values.residence_street}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.residence_street && errors.residence_street
                        }
                        autoCorrect="off"
                        spellCheck="off"
                        autoFocus={false}
                        autoComplete="off"
                      />

                      <Form.Control.Feedback type="invalid">
                        <span role="alert">
                          {touched.residence_street && errors.residence_street}
                        </span>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="m-0">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>Apartment/Suit</Form.Label>
                      <Form.Control
                        type="text"
                        name="residence_apartment"
                        placeholder=""
                        className=""
                        value={values.residence_apartment}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.residence_apartment &&
                          errors.residence_apartment
                        }
                        autoCorrect="off"
                        spellCheck="off"
                        autoFocus={false}
                        autoComplete="off"
                      />

                      <Form.Control.Feedback type="invalid">
                        <span role="alert">
                          {touched.residence_apartment &&
                            errors.residence_apartment}
                        </span>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="m-0">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        City
                        <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="residence_city"
                        placeholder=""
                        className=""
                        value={values.residence_city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.residence_city && errors.residence_city
                        }
                        autoCorrect="off"
                        spellCheck="off"
                        autoFocus={false}
                        autoComplete="off"
                      />

                      <Form.Control.Feedback type="invalid">
                        <span role="alert">
                          {touched.residence_city && errors.residence_city}
                        </span>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        State
                        <span className="form-required">*</span>
                      </Form.Label>
                      <AutoSuggestionSelectComponent
                        options={formattedStateOptions}
                        name="residence_state"
                        placeholder="Select State"
                        components={{
                          IndicatorSeparator: () => null,
                        }}
                        value={selectedResidenceState || null}
                        onChange={(e) => {
                          const event = {
                            target: { name: 'residence_state', value: e },
                          };
                          handleChange(event);
                          handlePersonalResidenceStateSelection(e);
                          setFieldValue('residence_state', e.value);
                        }}
                        fieldTouch={setFieldTouched}
                        //isSearchable={false}
                        inputClassName={
                          touched.residence_state && errors.residence_state
                            ? 'select-invalid-error'
                            : ''
                        }
                        isInvalid={
                          touched.residence_state && errors.residence_state
                        }
                      />
                      <div className="invalid-error-feedback">
                        <span role="alert">
                          {touched.residence_state && errors.residence_state}
                        </span>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="m-0">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        Zip
                        <span className="form-required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="residence_zip"
                        placeholder=""
                        className=""
                        value={values.residence_zip}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.residence_zip && errors.residence_zip
                        }
                        autoCorrect="off"
                        spellCheck="off"
                        autoFocus={false}
                        autoComplete="off"
                      />

                      <Form.Control.Feedback type="invalid">
                        <span role="alert">
                          {touched.residence_zip && errors.residence_zip}
                        </span>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md={12} className="different-address">
                    <Checkbox
                      label={'Use a different mailing address'}
                      checked={useDifferentMailingAddress}
                      onChange={(e) => {
                        setUseDifferentMailingAddress(e.target.checked);
                        /*setTimeout(() => {
                          if (!e.target.checked) {
                            setFieldValue('mailing_street', '');
                            setFieldValue('mailing_apartment', '');
                            setFieldValue('mailing_city', '');
                            setFieldValue('mailing_state', '');
                            setFieldValue('mailing_zip', '');
                            setMailingResidenceState('');
                          } else {
                            setFieldValue(
                              'mailing_street',
                              data?.mailingAddress.Address1,
                            );
                            setFieldValue('mailing_apartment', '');
                            setFieldValue(
                              'mailing_city',
                              data?.mailingAddress.City,
                            );
                            setFieldValue(
                              'mailing_state',
                              data?.mailingAddress.State,
                            );
                            setFieldValue(
                              'mailing_zip',
                              data?.mailingAddress.PostalCode,
                            );
                          }
                        }, 1000);*/
                      }}
                    />
                  </Col>
                </Row>
                {useDifferentMailingAddress && (
                  <>
                    <Row className="m-0 mt-4">
                      <Col md={12}>
                        <div className="p-0 m-0 mb-1 form-section">
                          Mailing Address
                        </div>
                        <Form.Group>
                          <Form.Label>
                            Street Address
                            <span className="form-required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="mailing_street"
                            placeholder=""
                            className=""
                            value={values.mailing_street}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.mailing_street && errors.mailing_street
                            }
                            autoCorrect="off"
                            spellCheck="off"
                            autoFocus={false}
                            autoComplete="off"
                          />

                          <Form.Control.Feedback type="invalid">
                            <span role="alert">
                              {touched.mailing_street && errors.mailing_street}
                            </span>
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label>Apartment/Suit</Form.Label>
                          <Form.Control
                            type="text"
                            name="mailing_apartment"
                            placeholder=""
                            className=""
                            value={values.mailing_apartment}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.mailing_apartment &&
                              errors.mailing_apartment
                            }
                            autoCorrect="off"
                            spellCheck="off"
                            autoFocus={false}
                            autoComplete="off"
                          />

                          <Form.Control.Feedback type="invalid">
                            <span role="alert">
                              {touched.mailing_apartment &&
                                errors.mailing_apartment}
                            </span>
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            City
                            <span className="form-required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="mailing_city"
                            placeholder=""
                            className=""
                            value={values.mailing_city}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.mailing_city && errors.mailing_city
                            }
                            autoCorrect="off"
                            spellCheck="off"
                            autoFocus={false}
                            autoComplete="off"
                          />

                          <Form.Control.Feedback type="invalid">
                            <span role="alert">
                              {touched.mailing_city && errors.mailing_city}
                            </span>
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            State
                            <span className="form-required">*</span>
                          </Form.Label>
                          <AutoSuggestionSelectComponent
                            options={formattedStateOptions}
                            name="mailing_state"
                            placeholder="Select State"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            value={selectedMailingResidenceState || null}
                            onChange={(e) => {
                              const event = {
                                target: {
                                  name: 'mailing_state',
                                  value: e,
                                },
                              };
                              handleChange(event);
                              handlePersonalMailingResidenceStateSelection(e);
                              setFieldValue('mailing_state', e.value);
                            }}
                            fieldTouch={setFieldTouched}
                            //isSearchable={false}
                            inputClassName={
                              touched.mailing_state && errors.mailing_state
                                ? 'select-invalid-error'
                                : ''
                            }
                            isInvalid={
                              touched.mailing_state && errors.mailing_state
                            }
                          />
                          <div className="invalid-error-feedback">
                            <span role="alert">
                              {touched.mailing_state && errors.mailing_state}
                            </span>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="m-0">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Zip
                            <span className="form-required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="mailing_zip"
                            placeholder=""
                            className=""
                            value={values.mailing_zip}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={
                              touched.mailing_zip && errors.mailing_zip
                            }
                            autoCorrect="off"
                            spellCheck="off"
                            autoFocus={false}
                            autoComplete="off"
                          />

                          <Form.Control.Feedback type="invalid">
                            <span role="alert">
                              {touched.mailing_zip && errors.mailing_zip}
                            </span>
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
                <Row className="mt-4">
                  <Col md={12} className="different-address">
                    <Checkbox label={'Update same address for Dependent(s)'} />
                  </Col>
                </Row>
                <Form.Group
                  className="form-block mt-3"
                  controlId="buttonsFormGroup"
                  style={{ padding: '16px' }}
                >
                  <Row>
                    <Col className="d-flex justify-content-end">
                      <GenericButton
                        variant="link"
                        onClick={() => {
                          //resetForm();
                          //prevStep();
                          setShowEditMemberContactDetails(false);
                        }}
                        className="form-btn"
                      >
                        Cancel
                      </GenericButton>
                      <GenericButton
                        type="submit"
                        className="mr-0"
                        disable={!isValid}
                        buttonDisabled={!isValid}
                        //disable={true}
                        //buttonDisabled={true}
                      >
                        UPDATE AND CONTINUE
                      </GenericButton>
                    </Col>
                  </Row>
                </Form.Group>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default EditMemberContactInfo;
